import Nullstack from 'nullstack';
export default function IconServerBolt({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-server-bolt",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "4",
    width: "18",
    height: "8",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M15 20h-9a3 3 0 0 1 -3 -3v-2a3 3 0 0 1 3 -3h12"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v.01"
  }), "   ", Nullstack.element("path", {
    d: "M7 16v.01"
  }), "   ", Nullstack.element("path", {
    d: "M20 15l-2 3h3l-2 3"
  }), " ");
}